import { WORLD_LEVELS, type WorldLevel } from '@/queries/constants'

export default function isLevelAtLeastMinLevel({
  level,
  minLevel,
}: {
  level?: WorldLevel | null
  minLevel: WorldLevel
}): boolean {
  return level == null ? false : WORLD_LEVELS.indexOf(level) >= WORLD_LEVELS.indexOf(minLevel)
}
